import {
  UploadState,
  UploadActionTypes,
  uploadAction,
} from "../../types/upload";

const initialState: UploadState = {
  uploadData: null,
  success: false,
  loading: false,
  error: null,
};

export const uploadReducer = (
  state: UploadState = initialState,
  action: uploadAction
): UploadState => {
  switch (action.type) {
    case UploadActionTypes.UPLOAD_FILE: {
      return { ...state, loading: true };
    }
    case UploadActionTypes.UPLOAD_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        uploadData: action.payload,
      };
    }
    case UploadActionTypes.UPLOAD_FILE_ERROR: {
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    }
    case UploadActionTypes.REMOVE_SEQUENCE: {
      return {
        ...state,
        uploadData: action.payload,
      };
    }

    case UploadActionTypes.PUT_UPLOAD_DATA: {
      return { ...state, success: false, loading: true };
    }
    case UploadActionTypes.PUT_UPLOAD_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
      };
    }
    case UploadActionTypes.PUT_UPLOAD_DATA_ERROR: {
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
